export const pluraliseMajors = (n: number) => {
  return n === 1 ? "major" : "majors";
};
